import request from "@/utils/request";

export function logout() {
  return request({
    url: "/system/user/logOut",
    method: "post"
  });
}

export function fetchList(params) {
  return request({
    url: "/system/user/getUserList",
    method: "get",
    params: params
  });
}

export function createAdmin(data) {
  return request({
    url: "/system/user/addUser",
    method: "post",
    data: data
  });
}

export function deleteAdmin(id) {
  return request({
    url: "/admin/delete/" + id,
    method: "post"
  });
}

export function getRoleByAdmin(id) {
  return request({
    url: "/system/user/getRoles/" + id,
    method: "get"
  });
}

//新加
// export function updateActivity(data) {
//   return request({
//     url: '/system/user/updateUserInfoByUserId',
//     method: 'post',
//     data: data
//   })
// }

export function updateAdmin(id, data) {
  return request({
    url: "/system/user/updateUserInfoByUserId/" + id,
    method: "post",
    data: data
  });
}
export function login(phone, password) {
  return request({
    url: "/system/user/login",
    method: "post",
    data: {
      phone,
      password
    }
  });
}
export function getInfo() {
  return request({
    url: "/system/user/info",
    method: "get"
  });
}
export function updateStatus(id, params) {
  return request({
    url: "/system/user/updateUserInfoByUserId/" + id,
    method: "post",
    params: params
  });
}
export function allocRole(data) {
  return request({
    url: "/system/user/assignRoles",
    method: "post",
    data: data
  });
}
export function disableUser(id, activity) {
  return request({
    url: "/system/user/disableUser/" + id + "/" + activity,
    method: "post"
  });
}
export function updateDetailAdmin(data) {
  return request({
    url: "/system/user/updateUserInfoByUserId",
    method: "post",
    data: data
  });
}
export function allDepartment() {
  return request({
    url: "/system/department/getDepartmentTree",
    method: "get"
  });
}
/**
 * 用户修改密码
 * @param {Object} data
 * @returns
 */
export function updatePassword(data) {
  return request({
    url: "/system/user/updatePassword",
    method: "post",
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js